module.exports = __webpack_public_path__ + "img/LMS Aset Illustration Jawaban Tersimpan.ae8e7b12.png";